import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneCountryPickerComponent } from './phone-country-picker/phone-country-picker.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MaterialModule } from '../../material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {AutoCompleteModule} from 'primeng/autocomplete';
@NgModule({
  declarations: [
    PhoneCountryPickerComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MaterialModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    AutoCompleteModule
  ],
  exports:[PhoneCountryPickerComponent]
})
export class PhoneCountryPickerModule { }
